export default {
  'weekday.message': 'On these days:'
};
